export enum ModalTestIds {
  DeleteModalConfirmButton = 'DeleteModalConfirmButton',
}
